import { Card } from '@consta/uikit/Card'

import { CardTool, CardToolContainer } from '../Cards'
import type { ActiveTools, ToolVariant } from '../types'
import css from './CardGroup.css'

type CardGroupProps<T extends string> = {
  tools: ToolVariant<T>[]
  activeTools: ActiveTools<T>
  onToolChanged: (tool: ToolVariant<T>) => void
}

export function CardGroup<T extends string>({
  tools,
  activeTools,
  onToolChanged,
}: CardGroupProps<T>) {
  return (
    <Card className={css.group} shadow={false}>
      {tools.map(tool => {
        switch (tool.type) {
          case 'select':
          case 'act':
          case 'activate':
            return (
              <CardTool
                key={tool.toolId}
                tool={tool}
                activeTools={activeTools}
                onToolChanged={onToolChanged}
              />
            )
          case 'container': {
            return (
              <CardToolContainer
                key={tool.toolId}
                tool={tool}
                activeTools={activeTools}
                onToolChanged={onToolChanged}
              />
            )
          }
        }
        return null
      })}
    </Card>
  )
}
